module.exports = __webpack_public_path__ + "img/freetag.c1d0726c.png";